import { Component } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoaderService } from '../../services/loader.service';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent {
  isLoading: Subject<boolean> = this.loaderService.isLoading;
  message: BehaviorSubject<string> = this.loaderService.message;
  constructor(private loaderService: LoaderService) { }
}
